<template>
  <section
    id="section-pricing"
    class="section section-red section-pricing"
  >
    <div class="container">
      <div class="row">
        <div class="col-9">
          <h2>
            {{ $t('home.subscribeToAnAffordablePlanUnlimited') }}
          </h2>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 mb-4 mb-lg-0">
          <a
            href="/register"
            class="unit text-decoration-none"
            :title="$t('auth.subscribeToTrial')"
          >
            <div class="content">
              <h5 class="price">
                &pound;10
              </h5>

              <h5 class="period">
                {{ $t('home.perMonth') }}
              </h5>

              <p>
                {{ $t('home.forOrganisationsTeachingUpTo', { number: 50 }) }}
              </p>
            </div>

            <span>
              {{ $t('auth.subscribeNow') }}
            </span>
          </a>
        </div>

        <div class="col-lg-3 mb-4 mb-lg-0">
          <a
            href="/register"
            class="unit text-decoration-none"
            :title="$t('auth.subscribeToTrial')"
          >
            <div class="content">
              <h5 class="price">
                &pound;15
              </h5>

              <h5 class="period">
                {{ $t('home.perMonth') }}
              </h5>

              <p>
                {{ $t('home.forOrganisationsTeachingUpTo', { number: 75 }) }}
              </p>
            </div>

            <span>
              {{ $t('auth.subscribeNow') }}
            </span>
          </a>
        </div>

        <div class="col-lg-3 mb-4 mb-lg-0">
          <a
            href="/register"
            class="unit text-decoration-none"
            :title="$t('auth.subscribeToTrial')"
          >
            <div class="content">
              <h5 class="price">
                &pound;20
              </h5>

              <h5 class="period">
                {{ $t('home.perMonth') }}
              </h5>

              <p>
                {{ $t('home.forOrganisationsTeachingOver', { number: 75 }) }}
              </p>
            </div>

            <span>
              {{ $t('auth.subscribeNow') }}
            </span>
          </a>
        </div>

        <div class="col-lg-3 mb-4 mb-lg-0">
          <ul class="checklist list-unstyled">
            <li>
              <font-awesome-icon icon="fa-solid fa-check" />
              7 {{ $t('features.dayFreeTrial') }}
            </li>

            <li>
              <font-awesome-icon icon="fa-solid fa-check" />
              {{ $t('features.accessToHundredsOfLessons') }} *
            </li>

            <li>
              <font-awesome-icon icon="fa-solid fa-check" />
              {{ $t('features.languageUpdatesIncluded') }}
            </li>

            <li>
              <font-awesome-icon icon="fa-solid fa-check" />
              {{ $t('features.shareMaterialWithYourTeam') }}
            </li>

            <li>
              <font-awesome-icon icon="fa-solid fa-check" />
              {{ $t('features.cancelAnytimeWithNoHassle') }}
            </li>
          </ul>

          <p>
            <font-awesome-icon icon="fa-solid fa-info-circle" />
            * {{ $t('home.shareLimits', { monthlyLessons: 20, monthlyDays: 30, annualLessons: 40, annualDays: 30 }) }}
          </p>
        </div>
      </div>

      <div class="notice d-none d-md-block">
        <a
          href="/register"
          class="btn btn-main btn-outline-light float-end"
          :title="$t('auth.subscribeToFreeTrial')"
        >
          {{ $t('auth.subscribeToFreeTrial') }}
        </a>

        <img
          src="images/icons/heart.svg"
          class="icon float-start"
          alt="Heart icon"
          width="65"
        >

        <p>
          {{ $t('home.annualPlan', { months: 2 }) }}
          <br>
          {{ $t('home.annualPlanPrices', [100, 150, 200]) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "Pricing",
  };
</script>
